import { Button, Flex, Tag, Text } from "@jsq/ds/core";
import { Sizes } from "@jsq/ds/styles";
import * as styles from "./styles_vanilla.css";
import type { CompareCellBase } from "./types";

export const EMPTY_VALUE_PLACEHOLDER = "—-";

export type CellValueProps = {
  cell: CompareCellBase;
  isLink?: boolean;
  onLinkClick?: () => void;
};

export const CellValue = ({ cell, isLink, onLinkClick }: CellValueProps) => {
  if (cell.tags?.length) {
    return (
      <Flex flexWrap="wrap" gap={Sizes.XS}>
        {cell.tags.map((tag) => (
          <Tag key={tag} className={styles.programTag}>
            {tag}
          </Tag>
        ))}
      </Flex>
    );
  }
  if (cell.lines) {
    return (
      <Flex flexDirection="column" alignItems="flex-start">
        {cell.lines.map((line, index) => (
          <Text key={`${line}-${index}`} variant="regular-md">
            {line}
          </Text>
        ))}
      </Flex>
    );
  }
  return (
    <Flex flexDirection="column" alignItems="flex-start">
      {isLink && onLinkClick ? (
        <Button
          displayAsLink
          variant="link"
          onClick={onLinkClick}
          data-testid="existing-positions-link"
        >
          {cell.value ?? EMPTY_VALUE_PLACEHOLDER}
        </Button>
      ) : (
        <Text variant="regular-md" className={isLink ? styles.linkText : undefined}>
          {cell.value ?? EMPTY_VALUE_PLACEHOLDER}
        </Text>
      )}
      {cell.subValue && <Text variant="secondary-md">{cell.subValue}</Text>}
    </Flex>
  );
};
